import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';
import { Box, Typography } from '@mui/material';
import { green, red } from '@mui/material/colors';
import React from 'react';

function PasswordStrengthReport({ report, textAlign }) {
  return (
    <Box sx={{ p: 1, textAlign: textAlign ?? 'center' }}>
      {Object.values(report).map(metric => (
        <span
          key={metric.description}
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: textAlign == 'left' ? 'unset' : 'center',
          }}
        >
          {metric.status ? <Check sx={{ fill: green[500] }} /> : <Close sx={{ fill: red[500] }} />}
          <Typography color={metric.status ? 'success' : 'error'} sx={{ fontSize: '0.75rem' }}>
            {metric.description}
            {metric.value ? ` >= ${metric.value}` : null}
          </Typography>
        </span>
      ))}
    </Box>
  );
}

export default PasswordStrengthReport;
